import { faArrowLeft, faCompress, faExpand } from "@fortawesome/pro-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { notification } from "antd";
import dayjs from "dayjs";
import React from "react";
import { globalAppConfig } from "../config";
import { CommandCenterView } from "../models/CommandCenterView";
import Clock from "./clock";
import { CommandProjectInfo } from "./CommandTypes";
import { JobsiteCommandContext } from "./JobsiteCommandProvider";
import JobsiteHours from "./jobsiteHoursUI";

interface CommandCenterHeaderProps {
    projectInfo: CommandProjectInfo;
    commandCenterView?: CommandCenterView;
}

const CommandCenterHeader: React.FC<CommandCenterHeaderProps> = ({ projectInfo, commandCenterView }) => {
    const commandContext = React.useContext(JobsiteCommandContext);
    const toggleFullScreen = () => {
        try {
            if (!document.fullscreenElement) {
                document.documentElement.requestFullscreen();
            } else if (document.exitFullscreen) {
                document.exitFullscreen();
            }
        } catch (err) {
            notification.error({
                message: "Fullscreen mode not supported on this device.",
                description: String(err),
                placement: "topRight",
                duration: globalAppConfig.NOTIFICATION_DURATION,
            });
        }
    };

    const exitJobsiteCommand = () => {
        window.history.back();
    };

    return (
        <header className="flex flex-row relative bg-neutral-900 border-b border-neutral-700 p-8 z-10">
            <div style={{ zIndex: -1 }} className="absolute inset-0 flowing-gradient opacity-40"></div>
            <div className="relative flex items-center justify-between w-full gap-8">
                <div className="flex flex-1 items-center gap-4 min-w-0">
                    <button className="cursor-pointer " type="button" onClick={exitJobsiteCommand}>
                        <FontAwesomeIcon icon={faArrowLeft} className="text-plot-darkmode-white" />
                    </button>
                    <button className="cursor-pointer" type="button" onClick={toggleFullScreen}>
                        <FontAwesomeIcon
                            icon={document.fullscreenElement ? faCompress : faExpand}
                            className="text-plot-darkmode-white"
                        />
                    </button>

                    <div className="rounded-lg flex items-center justify-center shadow-lg gc-logo-mask">
                        <img src={projectInfo?.avatar_url} alt="Team Logo" className="w-32 h-32 object-cover" />
                    </div>
                    <div className="flex flex-1 flex-col w-full">
                        <h1 className="text-5xl font-bold text-white uppercase line-clamp-2">
                            {projectInfo?.project_name}
                        </h1>
                        <div className="flex flex-row items-center gap-4 w-full">
                            <div className="flex flex-row gap-1 items-center">
                                <div className="w-3 h-3 rounded-full animate-pulse bg-plot-orange"></div>
                                <span className="font-medium text-sm text-plot-orange">LIVE</span>
                            </div>
                            <div className="text-sm text-gray-300">{commandCenterView?.name}</div>
                        </div>
                        <div className="flex flex-row items-center gap-2 w-full">
                            <div className="text-sm text-gray-300">Last Updated:</div>
                            <div className="text-sm text-gray-300">
                                {dayjs(commandContext?.lastUpdated ?? new Date()).format("MMMM D, YYYY h:mm A")}
                            </div>
                        </div>
                    </div>
                </div>
                <div className="flex flex-col items-center flex-1">
                    <JobsiteHours project={projectInfo} iconSize="2x" headerSize="text-xl" secondaryColor="#ffffff" />
                </div>

                <div className="flex flex-col items-end ">
                    <Clock timeZone={projectInfo?.timezone} />{" "}
                </div>
                <img
                    src="/img/png/logo/plot_jobsite_command.png"
                    alt="PLOT Logo"
                    className="opacity-90 h-28 w-auto shrink-0 invert"
                />
            </div>
        </header>
    );
};

export default CommandCenterHeader;
